import classNames from 'classnames';
import React from 'react';
import { ConnectedProps, connect } from 'react-redux';
import { compose } from 'redux';
import { TaskTypesEnum } from '@redux/tasks/tasksTypes';
import { ReduxState } from '@redux/types';
import { Button } from 'components/Button/Button';
import { GeneratingMessageTextArea, GeneratingMessageTextAreaProps } from 'components/GeneratingMessageTextArea/GeneratingMessageTextArea';
import AssessmentArea from 'containers/Tasks/components/AssessmentArea/AssessmentArea';
import style from './TaskContentArea.scss';

type TaskContentAreaProps = {
  taskType: TaskTypesEnum;
  setTaskType: (taskType: TaskTypesEnum) => void;
} & GeneratingMessageTextAreaProps;

type Props = ConnectedProps<typeof connectRedux> & TaskContentAreaProps;

const TaskContentArea: React.FC<Props> = ({ taskType, setTaskType, ...textGeneratingProps }) => {
  return (
    <>
      <div className={style.taskTypeTabContainer}>
        <Button variant="text" className={classNames(style.tab, taskType == TaskTypesEnum.MESSAGE ? style.active : {})} onClick={() => setTaskType(TaskTypesEnum.MESSAGE)}>
          Message
        </Button>
        <Button variant="text" className={classNames(style.tab, taskType == TaskTypesEnum.ASSESSMENT ? style.active : {})} onClick={() => setTaskType(TaskTypesEnum.ASSESSMENT)}>
          Assessment
        </Button>
      </div>

      {taskType === TaskTypesEnum.MESSAGE && <GeneratingMessageTextArea {...textGeneratingProps} />}
      {taskType === TaskTypesEnum.ASSESSMENT && <AssessmentArea {...textGeneratingProps} />}
    </>
  );
};

const connectRedux = connect((state: ReduxState) => ({}), {});

export default compose(connectRedux)(TaskContentArea);
